export default {
  "accounting.basicInfoRegSubjects": "勘定科目基本情報",
  "accounting.accountsAddOrEdit": "勘定科目作成・追加",
  "accounting.accountName": "勘定科目名",
  "accounting.accountCode": "勘定科目コード",
  "accounting.plsEnterAccountName": "勘定科目名を入力してください",
  "accounting.accountName.ex": "例) 買掛金",
  "accounting.functionClassification": "機能区分",
  "accounting.plsSelectFunctionClassification": "機能区分選択してください",
  "accounting.accountsPayable": "買掛金",
  "accounting.accountsReceivable": "売掛金",
  "accounting.applicableAccountingRules": "適用会計ルール",

  "accounting.management.cash": "現金",
  "accounting.management.odyDeposit": "普通預金",
  "accounting.management.accReceivable" : "売掛金",
  "accounting.management.otherReceivable": "未収入金",
  "accounting.management.inventory":  "棚卸資産",
  "accounting.management.otherAssets": "その他資産",
  "accounting.management.accPayable": "買掛金",
  "accounting.management.otherPayable": "未払金",
  "accounting.management.accuredExp": "未払費用",
  "accounting.management.advancePay": "前受金",
  "accounting.management.deposit": "預り金",
  "accounting.management.tempReceipt": "仮受金",
  "accounting.management.otherDebt": "その他負債",
  "accounting.management.earnings": "売上",
  "accounting.management.costOfSales": "売上原価",
  "accounting.management.adminExp": "販売管理費",
  "accounting.management.nonopIncome": "営業外収益",
  "accounting.management.nonopExp": "営業外費用",
  "accounting.management.suspenseAcc": "仮勘定",
  
};